import {Routes, Route, Link, Navigate} from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import {Provider} from "react-redux";
import store from './stores/userStore';

import {locale, addLocale} from 'primereact/api';


import './assets/css/vendors/themify.css'
import './assets/css/vendors/bootstrap.css'
import './assets/css/vendors/animate.css';
import './assets/css/vendors/select2.css';
import './assets/css/prime-theme.css';
import './assets/css/style.css';
import './assets/css/responsive.css'
import './assets/css/custom.css';
import './assets/css/vendors/feather-icon.css';
import './assets/css/vendors/font-awesome.css'
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"

import './assets/scss/custom.scss'

import {ProtectedRoute} from "./components/PrivateRoute";
import Users from "./pages/Users";
import UserEdit from "./pages/UserEdit";
import UserEdit2 from "./pages/UserEdit2";
import UserEditPassword from "./pages/UserEditPassword";
import UserEditAccess from "./pages/UserEditAccess";
import UserEditLearning from './pages/UserEditLearning'
import UserEditMoney from './pages/UserEditMoney'
import UserEditDocuments from "./pages/UserEditDocuments";
import UserEditWork from "./pages/UserEditWork";
import Clients from "./pages/Clients";
import Client from "./pages/Client";
import ClientChildren from "./pages/ClientChildren";
import ClientParents from "./pages/ClientParents";
import ClientComments from "./pages/ClientComments";
import ClientReceipts from "./pages/ClientReceipts";
import ClientDocuments from "./pages/ClientDocuments";
import ClientContracts from "./pages/ClientContracts";
import Attendance from "./pages/Attendance";
import Planing from "./pages/Planing";
import Finance from "./pages/Finance";
import Cash from "./pages/Cash";
import Departments from "./pages/Departments";
import Department from "./pages/Department";
import DepartmentMain from "./pages/DepartmentMain";
import DepartmentAdditional from "./pages/DepartmentAdditional";
import DepartmentGroup from "./pages/DepartmentGroup";
import Artists from "./pages/Artists";
import Artist from "./pages/Artist";
import Events from "./pages/Events";
import Event from "./pages/Event";
import Analyz from "./pages/Analyz";
import Analitic from "./pages/Analitic";
import CalcSplit from "./pages/CalcSplit";
import AnaliticFull from "./pages/AnaliticFull";
import KitchenArtists from "./pages/KitchenArtists";
import ArtistSales from "./pages/ArtistSales";

addLocale('ru', {
    firstDayOfWeek: 1,
    dayNames: ['понедельник', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
    dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    monthNames: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'],
    monthNamesShort: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сент', 'окт', 'ноя', 'дек'],
    today: 'Сегодня',
    clear: 'Очистить',
});
locale('ru')


function Home() {
    return (
        <>
            <main>
                <h2>Welcome to the homepage!</h2>
                <p>You can do this, I believe in you.</p>
            </main>
            <nav>
                <Link to="/about">About</Link>
            </nav>
        </>
    );
}

function About() {
    return (
        <>
            12312312
        </>
    );
}

function App() {
    return (
        <Provider store={store}>

            <Routes>

                <Route element={<ProtectedRoute/>}>
                    <Route path={'/'} element={<Clients/>}/>

                    <Route path={'cash'} element={<Cash/>}/>
                    <Route path={'clients'} element={<Clients/>}/>
                    <Route path={'client/:clientId'} element={<Client/>}/>
                    <Route path={'artists'} element={<Artists/>}/>
                    <Route path={'artist/:artistId'} element={<Artist/>}/>
                    <Route path={'events'} element={<Events/>}/>
                    <Route path={'analyz'} element={<Analyz/>}/>
                    <Route path={'analytic_full'} element={<AnaliticFull/>}/>
                    <Route path={'analytic'} element={<Analitic/>}/>
                    <Route path={'calc'} element={<Navigate to={'/calc-artist'} replace/>}/>
                    <Route path={'calc-artist'} element={<CalcSplit/>}/>
                    <Route path={'kitchen-artists'} element={<KitchenArtists/>}/>
                    <Route path={'artist-sales'} element={<ArtistSales/>}/>
                    <Route path={'event/:eventId'} element={<Event/>}/>
                </Route>
                <Route path="/login" element={<LoginPage/>}/>

            </Routes>
        </Provider>
    );
}

export default App;
